import * as React from "react";
import PropTypes from "prop-types";
const SvgAchievementsBadgeNormalMedium = React.forwardRef(
  ({ color = "currentColor", size = 32, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M16 5.818l5.5 3.074v6.216L16 18.182l-5.5-3.074V8.892zm-3 4.54v3.284l3 1.676 3-1.676v-3.284l-3-1.676z" />
        <path d="M14.403.465a3.25 3.25 0 013.194 0l7.75 4.372A3.25 3.25 0 0127 7.667v8.665a3.25 3.25 0 01-1.653 2.83l-1.347.76v9.379c0 2.174-2.522 3.376-4.21 2.006L16 28.234l-3.79 3.073c-1.688 1.37-4.21.168-4.21-2.006v-9.379l-1.347-.76A3.25 3.25 0 015 16.332V7.668a3.25 3.25 0 011.653-2.831zM10.5 21.332v7.969c0 .018.003.028.004.033a.044.044 0 00.005.012c.005.007.018.02.038.03.021.01.039.011.048.01a.044.044 0 00.013-.003.114.114 0 00.028-.017L16 25.016l5.364 4.35a.114.114 0 00.028.017.044.044 0 00.013.003c.01.001.027 0 .047-.01a.095.095 0 00.039-.03.044.044 0 00.005-.012.113.113 0 00.004-.033v-7.969l-3.903 2.202a3.25 3.25 0 01-3.194 0zm5.869-18.69a.75.75 0 00-.737 0l-7.75 4.372a.75.75 0 00-.382.654v8.664c0 .27.146.52.382.653l7.75 4.372a.75.75 0 00.737 0l7.75-4.372a.75.75 0 00.381-.653V7.668a.75.75 0 00-.382-.654z" />
      </g>
    </svg>
  )
);
SvgAchievementsBadgeNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgAchievementsBadgeNormalMedium;
